export default {
      id: "record-usage",
      viewBox: "0 0 576 512",
      url: __webpack_public_path__ + "img/icons.b8e1d04b.svg#record",
      toString: function () {
        return this.url;
      }
    }